export const settingsKeys = {
  root: ['settings'] as const,
  apiCredentials: () => [...settingsKeys.root, 'apiCredentials'] as const,
  apiCredential: (id: string) => [...settingsKeys.apiCredentials(), id] as const,
  ipWhitelist: (apiKey?: string) => [...settingsKeys.root, 'ipWhitelist', apiKey || ''] as const,
};
